<header class="headerContainer pad-t-2 pad-b-4 pad-r-b-3" *ngIf="!utilsService.feature?.includes('instruction')" [ngClass]="{'englishTestStyle': utilsService.feature === 'english-test', 'reasoningTestStyle': utilsService.feature === 'reasoning-test', 'digitalTestStyle': utilsService.feature === 'digital-test', 'adnTestStyle':( utilsService.feature === 'adn-test' || utilsService.feature === 'legal') }">

  <div class="container">

    <div class="mainHeader pad-r-0">
      <div class="d-flex justify-content-end translate-row">
        <ng-container *ngIf="currentLanguage && utilsService.feature !== 'error' && currentInvitation">
          <!-- Select Idiomas Desktop-->
          <div class="translate-desktop d-none d-lg-block body-xs body-r-xs">
            <div [ngClass]="{'activeLanguage': currentLanguage === 'en-GB'}" (click)="changeLanguage('en-GB')">EN</div>
            <div [ngClass]="{'activeLanguage': currentLanguage === 'pt-PT'}" (click)="changeLanguage('pt-PT')">PT</div>
            <div *ngIf="currentInvitation?.clientId === 1 || currentInvitation?.clientId === 5" [ngClass]="{'activeLanguage': currentLanguage === 'es-ES'}" (click)="changeLanguage('es-ES')">ES</div>
            <div *ngIf="currentInvitation?.clientId === 2" [ngClass]="{'activeLanguage': currentLanguage === 'es-AR'}" (click)="changeLanguage('es-AR')">ES</div>
            <div *ngIf="currentInvitation?.clientId === 3" [ngClass]="{'activeLanguage': currentLanguage === 'es-MX'}" (click)="changeLanguage('es-MX')">ES</div>
            <div *ngIf="currentInvitation?.clientId === 4" [ngClass]="{'activeLanguage': currentLanguage === 'es-CL'}" (click)="changeLanguage('es-CL')">ES</div>
            <div *ngIf="currentInvitation?.clientId === 6" [ngClass]="{'activeLanguage': currentLanguage === 'pt-BR'}" (click)="changeLanguage('pt-BR')">PT</div>
            <div *ngIf="currentInvitation?.clientId === 8" [ngClass]="{'activeLanguage': currentLanguage === 'es-UY'}" (click)="changeLanguage('es-UY')">ES</div>
          </div>

          <!-- Select Idiomas Mobile-->
          <div class="translate-mobile d-lg-none body-xs body-r-xs text-right position-relative color-light" (click)="toogleLanguageSelect('toogle')" (clickOutside)="toogleLanguageSelect('false')">
            <span class="mr-1">{{ currentLanguage?.split('-')[0].toUpperCase() }}</span>
            <div class="language-arrow" [ngStyle]="{'transform': customSelectService.currentCurstomSelectValue.showLanguage ? 'rotate(180deg)': 'rotate(0deg)'}">
            </div>
            <div class="languages" [ngStyle]="{'display': customSelectService.currentCurstomSelectValue.showLanguage ? 'block' : 'none'}">
              <div *ngFor="let lang of languagesNotSelected" (click)="changeLanguage(lang)">
                {{ lang.split('-')[0].toUpperCase() }}
              </div>
            </div>
          </div>
        </ng-container>
      </div>

      <div class="logo-row row">

        <!--fila de logos de la home -->
        <ng-container *ngIf="utilsService.feature === 'home' || utilsService.feature  === 'error' || utilsService.feature  === 'legal'">
          <!-- fila de logos si no hay cliente -->
          <ng-container *ngIf="!currentInvitation?.project?.logoBlackAndWhite">
            <div class="col-5 d-flex flex-column justify-content-center">
              <img *ngIf="utilsService.feature  !== 'legal'" src="/assets/images/relevate-talent-assessment-navy.png">
              <img *ngIf="utilsService.feature  === 'legal'" src="/assets/images/relevate-talent-assessment-navy.png">
            </div>
          </ng-container>
          <!-- fila de logos si hay cliente -->
          <ng-container *ngIf="currentInvitation?.project?.logoBlackAndWhite">
            <div class="col-5">
              <img [src]="currentInvitation?.project?.logoBlackAndWhite">
            </div>
            <div class="offset-3 col-4 d-flex flex-column justify-content-center align-items-end">
              <img src="/assets/images/randstad_logo_white.png">
            </div>
          </ng-container>
        </ng-container>

        <!-- fila de logos para el test-->
        <ng-container *ngIf="(utilsService.feature === 'english-test' || utilsService.feature === 'reasoning-test' || utilsService.feature === 'digital-test' || utilsService.feature === 'adn-test') && test$ | async as currentTest;">
          <!-- fila de logos si no hay cliente -->
          <ng-container *ngIf="!currentTest?.invitation?.project?.logoBlackAndWhite">
            <div class="col-5">
              <img *ngIf="(utilsService.feature === 'english-test' || utilsService.feature === 'reasoning-test' || utilsService.feature === 'digital-test')" src="/assets/images/relevate-talent-assessment-navy.png">
              <img *ngIf="(utilsService.feature === 'adn-test')" src="/assets/images/relevate-talent-assessment-navy.png">
            </div>
          </ng-container>
          <!-- fila de logos si hay cliente -->
          <ng-container *ngIf="currentTest?.invitation?.project?.logoBlackAndWhite">
            <div class="col-5">
              <img [src]="currentTest?.invitation?.project?.logoBlackAndWhite">
            </div>
            <div class="offset-3 col-4 d-flex flex-column justify-content-center align-items-end">
              <img src="/assets/images/randstad_logo_white.png">
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>
    <hr class="mar-t-2 mar-b-3 mar-r-b-2">

    <div *ngIf="utilsService.feature == 'home'">
      <div class="d-flex justify-content-between subheader">
        <div *ngIf="translateService.currentLang">
          <h1 class="title-xl title-r-m color-primary">{{ 'COMMON.HELLO' | translate }} {{ (candidate$ | async)?.name | titlecase }}</h1>
          <span class="title-m title-r-xs">{{ 'CANDIDATE.THESEAREYOURTESTS' | translate }}</span>
        </div>
      </div>
    </div>

  </div>

</header>
